import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type Compensation from 'modules/contracts/store/models/Compensation'

type ButtonTouchableProps = React.ComponentProps<typeof Button>

interface Props {
  compensation: Compensation
  handleRemove: ButtonTouchableProps['onClick']
  isSubmitDisabled: boolean
  onClick?: () => void
}

export const Footer = ({ compensation, handleRemove, isSubmitDisabled, onClick }: Props) => {
  const showRemove = !compensation.isNew || onClick
  return (
    <>
      {showRemove && (
        <Button onClick={handleRemove} type="negative">
          {i18n.t('common.remove')}
        </Button>
      )}
      {onClick && (
        <Button disabled={isSubmitDisabled} onClick={onClick}>
          {i18n.t('common.submit')}
        </Button>
      )}
      {!onClick && (
        <Button disabled={isSubmitDisabled} submit>
          {compensation ? i18n.t('common.submit') : i18n.t('common.save')}
        </Button>
      )}
    </>
  )
}
